import React from 'react'
import notFound from '../images/AppSection/404.gif'

function NotFoundPage() {
  return (
    <div style={{ textAlign: 'center' }}><img src={notFound} alt="" style={{ width: "50%"}}/></div>
  )
}

export default NotFoundPage